<mat-spinner [ngStyle]="{ margin: center ? '0 auto' : '0' }" [diameter]="diameter"></mat-spinner>
